export enum PaymentStatusTypes {
    SUCCESS = "success",
    CANCELLED = "cancelled",
    REQUIRED_ACTION = "requires_action",
    PROCESSING = "processing",
    REQUIRES_SOURCE_ACTION = "requires_source_action",
    FAILED = "failed"
}

